import $http from "../../helpers/api";

// initial state
const state = {
  all: [],
  issue: [],
  customer_issues: []
};

// getters
const getters = {
  get: state => state.issue,
  getAll: state => state.all,
  getCustomerIssues: state => state.customer_issues
};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      $http.get("/issues").then(resp => {
        commit("setAll", resp.data);
      });
      resolve();
    });
  },
  getCustomerIssues({ commit }) {
    return new Promise((resolve, reject) => {
      $http.get("/customer_issues").then(resp => {
        commit("setAllCustomerIssues", resp.data);
      });
      resolve();
    });
  }
};
const mutations = {
  setAll(state, data) {
    state.all = data;
  },
  setAllCustomerIssues(state, data) {
    state.customer_issues = data;
  },
  clearAll(state) {
    state.all = [];
    state.issue = [];
    state.customer_issues = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
